class EditMission {
  constructor(
    id,
    dispatchCurrentState,
    hospitalId,
    missionTags,
    cityId,
    address,
    dispatchZoneId,
    editableByFollowUp,
    allow1019,
    is247,
    is724,
    geographicalTypeId,
    isDeployed,
    hospitalCancelReason,
    missionLackOfCodes,
    uniqueId,
  ) {
    this.id = id;
    this.dispatchCurrentState = dispatchCurrentState;
    this.hospitalId = hospitalId;
    this.missionTags = missionTags;
    this.cityId = cityId;
    this.address = address;
    this.dispatchZoneId = dispatchZoneId;
    this.editableByFollowUp = editableByFollowUp;
    this.allow1019 = allow1019;
    this.is247 = is247;
    this.is724 = is724;
    this.geographicalTypeId = geographicalTypeId;
    this.isDeployed = isDeployed;
    this.hospitalCancelReason = hospitalCancelReason;
    this.missionLackOfCodes = missionLackOfCodes;
    this.uniqueId = uniqueId;
  }
}
export default {
  EditMission,
};
